import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DashboardComponent,
  CountryConfComponent,
  ConfirmComponent,
  DetailComponent,
} from './dashboard.component';

import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';

import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AuthGuard } from '../auth.guard';
import { EditProfileComponent } from './my-profile/edit-profile/edit-profile.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { TobaccoDashboardModule } from './tobacco-dashboard/tobacco-dashboard.module';
import { TobaccoDashboardComponent } from './tobacco-dashboard/tobacco-dashboard.component';


export const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    children: [
      {
        path: 'home',
        loadChildren: () =>
          import('./home/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'tobacco-cessation',
        component: TobaccoDashboardComponent,
      },
      {
        path: 'users',
        loadChildren: () =>
          import('./users/users.module').then((m) => m.UsersModule),
      },
      {
        path: 'my-profile',
        loadChildren: () =>
          import('./my-profile/my-profile.module').then(
            (m) => m.MyprofileModule
          ),
      },
      {
        path: 'my-profile/edit',
        component: EditProfileComponent,
      },
      {
        path: 'medicines',
        loadChildren: () =>
          import('./pharmacy/medicines/medicines.module').then(
            (m) => m.MedicinesModule
          ),
      },
      {
        path: 'examinations_test',
        loadChildren: () =>
          import('./pharmacy/examinations_tests/examinations_test.module').then(
            (m) => m.ExamTestModule
          ),
      },
      {
        path: 'interventions',
        loadChildren: () =>
          import('./pharmacy/interventions/interventions.module').then(
            (m) => m.InterventionsModule
          ),
      },
      {
        path: 'administrative',
        loadChildren: () =>
          import('./administrative/administrative.module').then(
            (m) => m.AdministrativeModule
          ),
      },
      {
        path: 'population',
        loadChildren: () =>
          import('./population/population.module').then(
            (m) => m.PopulationModule
          ),
      },
      { path: '**', redirectTo: 'home', pathMatch: 'full' },
    ],
    canActivate: [AuthGuard],
  },
];

@NgModule({
  declarations: [
    DashboardComponent,
    CountryConfComponent,
    ConfirmComponent,
    DetailComponent,
  ],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatMenuModule,
    MatDialogModule,
    MatSidenavModule,
    FlexLayoutModule,
    MatIconModule,
    MatToolbarModule,
    MatButtonModule,
    MatSelectModule,
    MatInputModule,
    MatIconModule,
    MatDatepickerModule,
    ScrollingModule,
    TobaccoDashboardModule
  ],
  bootstrap: [DashboardComponent],
  exports: [RouterModule],
  entryComponents: [CountryConfComponent, ConfirmComponent, DetailComponent],
  providers: [],
})
export class DashboardModule {}
